import React from "react";
import Layout from "../../../Layouts/Layout";
import { Link, useForm } from "@inertiajs/inertia-react";

const RequestDetail = ({ request, my_response }) => {
  const { data, setData, post, processing } = useForm({
    message: "",
    quote_amount: "",
  });

  function submit(e) {
    e.preventDefault();
    post(`/domestic/tradesman_requests/${request.id}/respond`);
  }

  return (
    <Layout title="Domestic Request">
      <div className="mt-4 max-w-3xl space-y-8">
        <Link
          href="/domestic/tradesman_requests"
          className="text-sm font-medium text-orange-600 hover:text-orange-500"
        >
          &larr; Back to requests
        </Link>

        <div className="rounded-md border border-gray-200 bg-white p-6">
          <h2 className="text-lg font-medium text-gray-900">
            {request.trades.join(", ")} — {request.postcode_district_code}
          </h2>
          <p className="mt-3 whitespace-pre-wrap text-sm text-gray-700">
            {request.description}
          </p>
          <p className="mt-3 text-xs text-gray-400">
            Posted {request.created_at}
            {request.ideal_start_date
              ? ` · Ideal start ${request.ideal_start_date}`
              : ""}
          </p>
        </div>

        {my_response ? (
          <div className="space-y-4">
            {my_response.status === "accepted" && (
              <div className="rounded-md border border-green-300 bg-green-50 p-6">
                <h3 className="text-sm font-semibold text-green-900">
                  🎉 You won this job — the customer accepted your enquiry.
                </h3>
                {my_response.customer_contact && (
                  <div className="mt-3 text-sm text-green-900">
                    <p className="font-medium">Customer details</p>
                    <p>{my_response.customer_contact.name}</p>
                    <p>{my_response.customer_contact.email}</p>
                    {my_response.customer_contact.phone && (
                      <p>{my_response.customer_contact.phone}</p>
                    )}
                    <p className="mt-2">
                      Get in touch to arrange the work.
                    </p>
                  </div>
                )}
              </div>
            )}
            {my_response.status === "declined" && (
              <div className="rounded-md border border-gray-300 bg-gray-50 p-6">
                <h3 className="text-sm font-medium text-gray-700">
                  The customer chose another tradesperson for this job.
                </h3>
                <Link
                  href="/domestic/tradesman_requests"
                  className="mt-2 inline-block text-sm font-medium text-orange-600 hover:text-orange-500"
                >
                  Browse other open requests &rarr;
                </Link>
              </div>
            )}
            <div className="rounded-md border border-blue-200 bg-blue-50 p-6">
              <h3 className="text-sm font-medium text-blue-900">
                Your enquiry (sent {my_response.created_at})
              </h3>
              <p className="mt-2 whitespace-pre-wrap text-sm text-blue-900">
                {my_response.message}
              </p>
              {my_response.quote_amount && (
                <p className="mt-2 text-sm font-semibold text-blue-900">
                  Quote: £{my_response.quote_amount}
                </p>
              )}
            </div>
          </div>
        ) : (
          <form
            onSubmit={submit}
            className="rounded-md border border-gray-200 bg-white p-6 space-y-4"
          >
            <h3 className="text-lg font-medium text-gray-900">
              Make an enquiry
            </h3>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Message to the customer
              </label>
              <textarea
                rows={4}
                required
                value={data.message}
                onChange={(e) => setData("message", e.target.value)}
                placeholder="Introduce yourself and how you can help…"
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-orange-500 focus:outline-none focus:ring-orange-500 sm:text-sm"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Quote (£, optional)
              </label>
              <input
                type="number"
                min="0"
                step="0.01"
                value={data.quote_amount}
                onChange={(e) => setData("quote_amount", e.target.value)}
                className="mt-1 block w-40 rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-orange-500 focus:outline-none focus:ring-orange-500 sm:text-sm"
              />
            </div>
            <button
              type="submit"
              disabled={processing}
              className="inline-flex justify-center rounded-md border border-transparent bg-orange-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 disabled:opacity-50"
            >
              Send enquiry
            </button>
          </form>
        )}
      </div>
    </Layout>
  );
};

export default RequestDetail;
